import React from 'react';
import PropTypes from 'prop-types';

function DoctorQuestionsSection({ doctorQuestions }) {
  return (
    <div className="questions-section">
      <h3>❓ Important Questions for Your Doctor</h3>
      <div className="questions-list">
        {doctorQuestions.map((question, index) => (
          <div key={index} className="question-item">
            <span className="question-number">{index + 1}</span>
            <span className="question-text">{question}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

DoctorQuestionsSection.propTypes = {
  doctorQuestions: PropTypes.array.isRequired,
};

export default DoctorQuestionsSection;